import { Link } from "@mui/material";
import { type LucideIcon } from "lucide-react";

/**
 * Opens a source of the plan (PR, issue, procedure) in a new tab. Sources the
 * agent recorded without a URL are shown as plain text.
 */
export const EvidenceLink = ({
  href,
  label,
  icon: Icon,
}: {
  href: string | undefined;
  label: string;
  icon: LucideIcon;
}) => {
  const content = (
    <>
      <Icon size={12} className="shrink-0 text-gray-500" />
      <span className="truncate text-sm">{label}</span>
    </>
  );
  const className = "inline-flex min-w-0 items-center gap-[5px] text-sm";

  return href ? (
    <Link
      href={href}
      target="_blank"
      rel="noreferrer"
      underline="hover"
      className={className}
    >
      {content}
    </Link>
  ) : (
    <span className={className}>{content}</span>
  );
};
